/** Literal pin resolved to the promoted latest at load/stamp time. */
export const PHONE_RUNTIME_LATEST = "latest";

/** Regular Peekie phone runtime folder names: X.Y.Z only. */
export const SEMVER_PHONE_VERSION_RE = /^\d+\.\d+\.\d+$/;

/** Studio schema phone. Servable on CDN; not a case pin and never latest. */
export const STUDIO_BETA_PHONE_VERSION_RE = /^studio-beta-\d+\.\d+\.\d+$/;

export const STUDIO_BETA_PHONE_VERSION = "studio-beta-0.1.1";

export function isSemverPhoneVersion(version: string): boolean {
  return SEMVER_PHONE_VERSION_RE.test(version);
}

export function isStudioBetaPhoneVersion(version: string): boolean {
  return STUDIO_BETA_PHONE_VERSION_RE.test(version);
}

/** True for the Studio phone line: 0.3.x and any 1.x+. */
export function isStudioPhoneVersion(version: string): boolean {
  if (!isSemverPhoneVersion(version)) return false;
  const [major, minor] = version.split(".").map((part) => Number(part));
  return (major ?? 0) > 0 || (major === 0 && (minor ?? 0) >= 3);
}

/** Tokens allowed as R2/CDN release folder names (serve, not pin). */
export function isServablePhoneReleaseVersion(version: string): boolean {
  return isSemverPhoneVersion(version) || isStudioBetaPhoneVersion(version);
}
